
import React from 'react';
import { PhaseRange } from './chartDataUtils';
import { phaseColors } from '@/utils/cycle-tracking';

interface PhaseLegendProps {
  phaseRanges: PhaseRange[];
  highlightedPhase: string | null;
  setHighlightedPhase: (phase: string | null) => void;
}

export const PhaseLegend: React.FC<PhaseLegendProps> = ({ 
  phaseRanges, 
  highlightedPhase, 
  setHighlightedPhase 
}) => {
  return (
    <div className="flex flex-wrap justify-center gap-2 mt-2">
      {phaseRanges.map((range, idx) => (
        <div 
          key={`legend-${idx}`}
          className="flex items-center text-xs"
          onMouseEnter={() => setHighlightedPhase(range.phase)}
          onMouseLeave={() => setHighlightedPhase(null)}
        >
          <div 
            className="w-3 h-3 mr-1 rounded-sm" 
            style={{ backgroundColor: phaseColors[range.phase as keyof typeof phaseColors] }}
          />
          <span>{range.phase.charAt(0).toUpperCase() + range.phase.slice(1)}</span>
        </div>
      ))}
    </div>
  );
};
